export const GET_REPORTS = 'GET_REPORTS'
export const GET_REPORTS_SUCCESSFUL = 'GET_REPORTS_SUCCESSFUL'
export const GET_REPORTS_ERROR = 'GET_REPORTS_ERROR'